import Layout from '@/apps/layout/components'
import { MainGames } from '@/apps/MainGames/components'
import React from 'react'

const Home = (): React.ReactElement => {
  return (
    <Layout isFooter={false}>
      <MainGames />
    </Layout>
  )
}

export default Home
